import Model from './model';

class Message extends Model {
  constructor(_id, createdTime, updateTime, role, content) {
    super();
    this._id = _id;
    this.createdTime = createdTime;
    this.updateTime = updateTime;
    this.role = role;
    this.content = content;
  }
}

export default class Conversation extends Model {
  /**
   * Constructor
   */
  constructor(_id, createdTime, updateTime, app, messages) {
    super();
    this._id = _id;
    this.createdTime = createdTime;
    this.updateTime = updateTime;
    this.app = app;
    this.messages = messages.map(({ _id, ct, ut, r, c }) => new Message(_id, ct, ut, r, c));
  }
  getJson() {
    const { _id, version, app, messages } = this;
    return {
      _id,
      v: version,
      a: app,
      m: messages,
    };
  }
}
